import styled from 'styled-components';

import { addFocusStyle } from '../../lib/mixins';
import { pxToRem } from '../../lib/utils';

export const StyledButton = styled.button`
  padding: ${pxToRem(15)} ${pxToRem(25)};
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${pxToRem(18)};
  font-weight: 700;
  line-height: normal;
  text-align: center;
  border: 1px solid;
  border-radius: 100rem;
  transition: background-color 0.3s ease-in-out, color 0.2s ease-in-out;
  cursor: pointer;
  overflow: visible;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:not(:disabled):hover {
    color: ${({ theme }) => theme.colors.b};
    background-color: ${({ theme }) => theme.colors.e};
    border-color: ${({ theme }) => theme.colors.e};
  }

  &:not(:disabled):focus {
    ${addFocusStyle()}
  }

  ${(props) =>
    props.alternate
      ? `
    color: ${props.theme.colors.brand};
    background-color: ${props.theme.colors.b};
    border-color: ${props.theme.colors.brand};
  `
      : `
    color: ${props.theme.colors.b};
    background-color: ${props.theme.colors.brand};
    border-color: transparent;
  `}
`;
